import { useEffect } from "react";

const useMicroSceneBubbles = ({ messages, parseMicroSceneData, setMicroSceneBubbles }) => {
  useEffect(() => {
    const newMicroScenes = messages
      .filter((msg) => msg.role === "Micro_scene")
      .flatMap((msg) => parseMicroSceneData(msg.context));

    setMicroSceneBubbles((prevBubbles) => {
      const newBubbles = newMicroScenes.filter(
        (scene) => !prevBubbles.some((prevScene) => prevScene.id === scene.id)
      );
      return [...prevBubbles, ...newBubbles];
    });
  }, [messages, parseMicroSceneData, setMicroSceneBubbles]);
};

export default useMicroSceneBubbles;
